import { render, staticRenderFns } from "./LogPagination.vue?vue&type=template&id=2fc348c8"
import script from "./LogPagination.vue?vue&type=script&lang=js"
export * from "./LogPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports